import React from 'react';
import { Outlet } from 'react-router-dom';

const ContactHome = () => (
  <section className="app-route">
    <Outlet />
  </section>
);

export default ContactHome;